import { render, staticRenderFns } from "./handbook.vue?vue&type=template&id=41d506ef"
import script from "./handbook.vue?vue&type=script&lang=js"
export * from "./handbook.vue?vue&type=script&lang=js"
import style0 from "./handbook.vue?vue&type=style&index=0&id=41d506ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports